module.exports = __webpack_public_path__ + "static/vendor-faq-shop-7ba4734dda3fec11d073ead0aaa13a5c.png";